import { render, staticRenderFns } from "./statusChart.vue?vue&type=template&id=6facf55d&"
import script from "./statusChart.vue?vue&type=script&lang=js&"
export * from "./statusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports